<template>
  <div>
    <CRow>
      <CCol sm="6">
        <div class="card-title mb-3">
          {{ $t("role.settings.producer.title") }}
        </div>
      </CCol>
    </CRow>

    <CRow v-if="data" class="p-3">
      <div v-if="data.length > 0" class="w-100">
        <Header
          :data="[
            $t('models.productproducer.producer'),
            $t('models.mpc.market_wh'),
            $t('models.mpc.price_mode'),
            $t('models.mpc.recharge'),
            $t('models.family_address.country'),
            $t('models.family_address.phone'),
            $t('models.logistics.connections.contacts'),
            $t('models.logistics.connections.serviceZone'),
            'Actions',
          ]"
        />
        <Row
          v-for="(item, index) in data"
          :key="index"
          :data="[
            {
              data: producerName(item.producer.role.name, item.producer.id),
              type: 'html',
            },
            { data: warehouse(item.market_wh), type: 'html' },
            { data: priceMode(item.price_mode), type: 'html' },
            { data: margin(item.recharge), type: 'html' },
            { data: item.producer.role.country, type: 'text' },
            { data: item.producer.role.tel, type: 'text' },
            { data: item.producer.role.info_contact, type: 'text' },
            { data: item.producer.role.desc_zone, type: 'text' },
            { data: '', type: 'actions' },
          ]"
          :border="true"
          :topAligned="true"
        >
          <template #actions>
            <div class="d-flex justify-content-end">
              <CButton
                class="mr-2 mt-2"
                size="sm"
                color="primary"
                @click="editProducer(item)"
              >
                <font-awesome-icon icon="edit" />
              </CButton>
            </div>
          </template>
        </Row>
      </div>
      <div
        v-else
        class="d-flex justify-content-center align-items-center w-100"
      >
        <CSpinner color="primary" />
      </div>
    </CRow>

    <SettingsProducerModal
      :show.sync="modal.show"
      :title="modal.title"
      :values="modal.values"
      :edit-mode="modal.editMode"
      :edit-id="modal.editId"
      :priceModes="priceModes"
      @submitted="fetchData"
    />
  </div>
</template>
<script>
import { apiGet, apiPatch } from "../../../helpers/apiHelper";
import Row from "../../../common/table/Row.vue";
import Header from "../../../common/table/Header.vue";
import SettingsProducerModal from "./SettingsProducerModal.vue";

export default {
  components: {
    Row,
    Header,
    SettingsProducerModal,
  },
  data() {
    return {
      data: [],
      whData: [],
      priceModes: [
        { id: 0, label: this.$t("models.mpc.price_modes.optionNone") },
        { id: 1, label: this.$t("models.mpc.price_modes.optionTrue") },
        { id: 2, label: this.$t("models.mpc.price_modes.optionFalse") },
      ],
      modal: {
        show: false,
        title: "",
        editMode: false,
        editId: null,
        values: {},
      },
    };
  },

  methods: {
    producerName(name, id) {
      return `<strong>${name}</strong><br>P-${id}`;
    },

    warehouse(whId) {
      const wh = this.whData.find((w) => w.id === whId);
      return wh ? `${wh.address.to}` : "";
    },

    margin(recharge) {
      return `${recharge} %`;
    },

    priceMode(modeId) {
      const mode = this.priceModes.find((m) => m.id === modeId);
      return mode ? mode.label : "";
    },

    async editProducer(item) {
      this.modal.title = item.producer.role.name;
      this.modal.values = item;
      this.modal.editMode = true;
      this.modal.editId = item.id;
      this.modal.show = true;
    },

    async fetchData() {
      const response = await apiGet(
        "role_marketproducer_connections",
        [this.$store.state.role.id],
        null
      );
      if (response && response.status === 200) {
        this.data = response.data.Items.sort(
          (a, b) => a.producer.id - b.producer.id
        );
      } else {
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error loading producer connections data",
          color: "danger",
          autohide: true,
        });
      }
    },

    async getWhData() {
      const response = await apiGet(
        "role_market_planningwh",
        [this.$store.state.role.id],
        null
      );
      if (response && response.status === 200) {
        this.whData = response.data.Items;
        await this.fetchData();
      } else {
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error loading warehouse data",
          color: "danger",
          autohide: true,
        });
      }
    },
  },

  async created() {
    await this.getWhData();
  },
};
</script>
